import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  name: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundaryDebug extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error,
      errorInfo: null
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(`[ErrorBoundary:${this.props.name}] BŁĄD WYCHWYCONY:`, {
      name: this.props.name,
      error: {
        message: error.message,
        name: error.name,
        stack: error.stack
      },
      errorInfo: {
        componentStack: errorInfo.componentStack
      },
      timestamp: new Date().toISOString()
    });

    // Przeanalizuj stack trace
    if (error.stack) {
      const stack = error.stack;
      console.error(`[ErrorBoundary:${this.props.name}] ANALIZA STACK TRACE:`);
      
      if (stack.includes('socket.io')) {
        console.error('  🎯 Prawdopodobne źródło: socket.io-client');
      }
      if (stack.includes('pdfmake')) {
        console.error('  🎯 Prawdopodobne źródło: pdfmake');
      }
      if (stack.includes('lucide-react')) {
        console.error('  🎯 Prawdopodobne źródło: lucide-react');
      }
      if (stack.includes('react-dom')) {
        console.error('  🎯 Prawdopodobne źródło: react-dom');
      }
      if (stack.includes('Illegal constructor')) {
        console.error('  🎯 BŁĄD: Illegal constructor - sprawdź konstruktory Node.js');
      }
    }

    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', border: '2px solid red', margin: '10px', background: '#ffe6e6' }}>
          <h3 style={{ color: 'red', marginTop: 0 }}>Błąd w komponencie: {this.props.name}</h3>
          <details style={{ marginTop: '10px' }}>
            <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>Szczegóły błędu (kliknij aby rozwinąć)</summary>
            <pre style={{ 
              background: '#f5f5f5', 
              padding: '10px', 
              overflow: 'auto', 
              fontSize: '12px',
              marginTop: '10px'
            }}>
              <strong>Błąd:</strong> {this.state.error?.message}
              {'\n\n'}
              <strong>Stack trace:</strong>
              {'\n'}
              {this.state.error?.stack}
              {'\n\n'}
              <strong>Component stack:</strong>
              {'\n'}
              {this.state.errorInfo?.componentStack}
            </pre>
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundaryDebug;

